import { Field,reduxForm, initialize } from 'redux-form';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdditionServiceCheckbox from '../components/AdditionServiceCheckbox';
import * as homeActions from '../actions/homeActions';
import LoadingOverlay from '../components/LoadingOverlay';
import BookingConfirmationForm from '../forms/BookingConfirmationForm';


class ReceiptDetailForm extends React.Component{

    constructor(props){
        super(props);
    }


    render(){
        const {selectedLocation,isLoading}=this.props;

        return (
            <div className="">
                 {/* <LoadingOverlay loading={isLoading} spinnerStyle={{ top: "20%" }}> */}
                     <form>
                         <div className="col-12 col-xs-12 mb-3 pt-3">
                             <div className="">
                                 <div className="">
                                    <h5 className="one-line-truncate bold">
                                        {`${selectedLocation.name}`}
                                    </h5>
                                    <p className="address">
                                        {`${selectedLocation.address.line1}, ${selectedLocation.address.line2}, ${selectedLocation.address.county}, ${selectedLocation.address.country}, ${selectedLocation.address.postCode}`}
                                    </p>
                                 </div>
                             </div>
                         </div>


                     </form>
                 {/* </LoadingOverlay> */}
            </div>
        );
    }

}

ReceiptDetailForm.propTypes = {
    isLoading: PropTypes.bool,
    pricing:PropTypes.object.isRequired,
    selectedLocation:PropTypes.object.isRequired
};


function mapStateToProps(state) {
    return {
        pricing:state.pricing
    };
}

export default connect(
    mapStateToProps,
    null
  )(ReceiptDetailForm);


// WEBPACK FOOTER //
// ./src/forms/ReceiptDetailForm.jsx